import React, { useEffect, useContext, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import ModalImage from 'react-modal-image';
import { SimpleShareButtons } from 'react-simple-share';
import { AppContext } from '../../core/Contexts/AppContext';
import { getDangerProductDetails } from '../../core/services';

const DetailDangerProduct = () => {
  const params = useParams();

  const [product, setProduct] = useState();
  const [showMore, setShowMore] = useState(false);
  const { setTitle, setHeaderType } = useContext(AppContext);

  const getValue = (value) => {
    return value ? value : 'უცნობია';
  };

  useEffect(() => {
    setTitle('საფრთხის შემცველი პროდუქტები');
    // setImage('./../images/hero-images/danger-products.png');

    setHeaderType(1);
  }, []);

  useEffect(() => {
    void getDangerProductDetails(params.id).then((result) => {
      setProduct(result);
    });
  }, [params.id]);

  if (!product) {
    return <div>No product details available</div>;
  }

  return (
    <section className='bg__gray-2'>
      <div className='container'>
        <div className='row'>
          <div className='col-md-5'>
            <div className='project-info-box mt-0'>
              <h6>
                <b>{getValue(product.product_title)}</b>
              </h6>
            </div>

            <div className='project-info-box'>
              <p>
                <b>პროდუქტის აღწერა:</b> {getValue(product.product_description)}
              </p>
              <p>
                <b>შეუსაბამობისა და საფრთხის მოკლე აღწერა:</b>
                <br />
                {getValue(product.danger_description)}
              </p>
              <p>
                <b>რისკის ტიპი:</b> {getValue(product.risk_type_text)}
              </p>
              <p>
                <b>გამოქვეყნებულია:</b> {getValue(product.event_held_date)}
              </p>

              {showMore && (
                <>
                  <p>
                    <b>სავაჭრო ნიშანი:</b> {getValue(product.trademark)}
                  </p>
                  <p>
                    <b>ქვეყანა:</b> {getValue(product.country_name)}
                  </p>
                  <p>
                    <b>კატეგორია:</b> {getValue(product.category_name)}
                  </p>
                  <p>
                    <b>მოდელი:</b> {getValue(product.serial_number)}
                  </p>

                  <p>
                    <b>შეფუთვის აღწერა:</b>{' '}
                    {getValue(product.product_package_desc)}
                  </p>
                </>
              )}
              <button
                className='btn btn-link p-0 mt-2'
                onClick={() => setShowMore(!showMore)}
              >
                {showMore ? 'ნაკლების ნახვა' : 'მეტის ნახვა'}
              </button>
            </div>

            <div className='project-info-box mt-0 mb-0'>
              <div className='shareProduct'>
                <b>გააზიარე: </b>
                <SimpleShareButtons
                  url={window.location.href}
                  whitelist={['Facebook', 'Twitter', 'LinkedIn']}
                  size='40px'
                />
              </div>
            </div>
          </div>

          <div className='col-md-7 dp-image-wrapper'>
            <ModalImage
              className='rounded modal-image w-100 mb-3 mt-m20 '
              alt={getValue(product.product_title)}
              small={`${process.env.REACT_APP_FORMS_URl}/uploads/${product.doc}`}
              large={`${process.env.REACT_APP_FORMS_URl}/uploads/${product.doc}`}
              hideDownload={true}
              hideZoom={true}
            />
            <div className='project-info-box'>
              <p>
                <b>გატარებული ღონისძიება:</b> {getValue(product.held_text)}
              </p>
              <p>
                <b>ძალაში შესვლის თარიღი:</b>{' '}
                {getValue(product.event_held_date)}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DetailDangerProduct;
